import React from 'react'

const PauseIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4736_23678)">
        <path
          d="M2.25 9C2.25 9.88642 2.42459 10.7642 2.76381 11.5831C3.10303 12.4021 3.60023 13.1462 4.22703 13.773C4.85382 14.3998 5.59794 14.897 6.41689 15.2362C7.23583 15.5754 8.11358 15.75 9 15.75C9.88642 15.75 10.7642 15.5754 11.5831 15.2362C12.4021 14.897 13.1462 14.3998 13.773 13.773C14.3998 13.1462 14.897 12.4021 15.2362 11.5831C15.5754 10.7642 15.75 9.88642 15.75 9C15.75 8.11358 15.5754 7.23583 15.2362 6.41689C14.897 5.59794 14.3998 4.85382 13.773 4.22703C13.1462 3.60023 12.4021 3.10303 11.5831 2.76381C10.7642 2.42459 9.88642 2.25 9 2.25C8.11358 2.25 7.23583 2.42459 6.41689 2.76381C5.59794 3.10303 4.85382 3.60023 4.22703 4.22703C3.60023 4.85382 3.10303 5.59794 2.76381 6.41689C2.42459 7.23583 2.25 8.11358 2.25 9Z"
          stroke="#DCAE1D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M9 12V12.0075" stroke="#DCAE1D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M9 9.74982C9.33731 9.75084 9.66512 9.63813 9.93049 9.4299C10.1959 9.22166 10.3833 8.93007 10.4625 8.60219C10.5418 8.27432 10.5082 7.9293 10.3672 7.62287C10.2262 7.31643 9.98605 7.06646 9.6855 6.91332C9.38713 6.76048 9.04583 6.71309 8.71711 6.77886C8.38839 6.84463 8.09159 7.0197 7.875 7.27557"
          stroke="#DCAE1D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4736_23678">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PauseIcon
